import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Router } from '@angular/router';
import { CustomerService } from '../../../core/services/customer.service';
import { OtherReservationService } from '../../../core/services/other-reservation.service';
import { Pagination } from '../../../core/dto/pagination';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '../../../modules/auth/services/auth.service';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';
import { FleetService } from '../../../core/services/fleet.service';

@Component({
  selector: 'app-other-reservation',
  templateUrl: './other-reservation.component.html',
  styleUrls: ['./other-reservation.component.scss'],
})
export class OtherReservationComponent implements OnInit {
  breadcrumbs: any[] = [
    {
      title: 'Other Booking',
      icon: 'car',
    },
  ];
  loading = false;
  searchText: any;
  statusFilter: any;
  dateFilter: any;
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;
  otherReservationData: any[] = [];
  isVisibleFuelAndMileageUpdate = false;
  changingStatus: any;
  selectedReservation: any;
  isLoading = false;
  fuelLevel = 0;
  mileage = 0;
  cancelReason: any = null;
  index = 0;
  skeletonTableColumns: any[] = [
    'Booking ID',
    'Reason',
    'Number of Days',
    'Arrival Date and Time',
    'Departure Date and Time',
    'Vehicle category',
    'Allocated vehicle reg. No',
    'Status',
    'Created Date',
    'Action',
  ];
  cancelReasonOptions: any[] = [
    'No Show',
    'No International License',
    'No Local License',
    'Vehicle Non Availability',
  ];

  // formatterPercentFuel = (value: number): string => `${value} %`;
  // parserPercentFuel = (value: string): string => value.replace(' %', '');
  // formatterDistance = (value: number): string => `${value} KM`;
  // parserDistance = (value: string): string => value.replace(' KM', '');

  constructor(
    private router: Router,
    private otherReservationService: OtherReservationService,
    private messages: NzMessageService,
    private authService: AuthService,
    private fleetService: FleetService,
  ) {}

  ngOnInit() {
    this.getPagedOtherReservations();
  }

  search() {
    this.getPagedOtherReservations();
  }

  onChangeDateFilter(result: Date[]): void {
    this.getPagedOtherReservations();
  }
  resetSearch() {
    this.searchText = null;
    this.statusFilter = null;
    this.dateFilter = null;
    this.getPagedOtherReservations();
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedOtherReservations();
  }

  getPagedOtherReservations(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchValue: this.searchText,
        status: this.statusFilter,
        dateFilter: this.dateFilter,
      },
    });
    this.otherReservationService
      .getOtherReservationsPaged(payload)
      .then((res: any) => {
        this.loading = false;
        this.otherReservationData = res.data;
        this.pageSize.length = res.totalItems;
      });
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedOtherReservations();
  }

  navigateNewOtherBooking(): void {
    this.router.navigate([`admin/booking-other/add-edit`]);
  }

  navigateToSingle(data: any): void {
    this.router.navigate([`admin/booking-other/${data}`]);
  }

  editNavigate(data: any): void {
    this.router.navigate([`admin/booking-other/add-edit/${data}`]);
  }

  handleCancelSelectStatus(): void {
    this.changingStatus = null;
    this.isVisibleFuelAndMileageUpdate = false;
  }

  handleOkSelectStatus(status: string, data: any): void {
    this.changingStatus = status;
    this.selectedReservation = data;
    if (status === 'ON_OTHER_TOUR' || status === 'COMPLETED') {
      if (data?.allocationDetails?.driverCategory !== 'OUTSOURCE_DRIVER') {
        this.isVisibleFuelAndMileageUpdate = true;
      } else {
        this.isLoading = true;
        this.otherReservationService
          .updateBooking({
            _id: this.selectedReservation._id,
            status,
            updateType: 'status_change',
          })
          .then(
            () => {
              this.isLoading = false;
              this.messages.create('success', `Status Changed to ${status}`);
              this.getPagedOtherReservations();
              this.changingStatus = null;
              this.selectedReservation = null;
            },
            (e: any) => {
              this.isLoading = false;
              this.messages.create('error', 'Error');
            },
          );
      }
    } else if (status === 'CANCELLED') {
      this.isVisibleFuelAndMileageUpdate = true;
    } else {
      this.otherReservationService
        .updateBooking({
          _id: this.selectedReservation._id,
          status: 'RESERVATION',
          updateType: 'status_change',
        })
        .then(
          (res: any) => {
            this.isLoading = false;
            this.messages.create('success', 'Status Changed to RESERVATION');
            this.getPagedOtherReservations();
            this.changingStatus = 0;
            this.selectedReservation = 0;
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    }
  }

  handleCancelUpdateFuelAndMileage(): void {
    this.isVisibleFuelAndMileageUpdate = false;
    this.fuelLevel = 0;
    this.mileage = 0;
    this.selectedReservation = null;
    this.changingStatus = null;
  }

  handleOkCancelledStatus(): void {
    this.isLoading = true;
    let remarks: any[] = this.selectedReservation?.remarks;
    if (remarks?.length > 0) {
      remarks?.push({
        action: 'Cancelled',
        remark: this.cancelReason,
        createdBy: this.authService.getLoggedInUser().userId,
      });
    } else {
      remarks = [
        {
          action: 'Cancelled',
          remark: this.cancelReason,
          createdBy: this.authService.getLoggedInUser().userId,
        },
      ];
    }
    this.otherReservationService
      .updateBooking({
        _id: this.selectedReservation._id,
        status: 'CANCELLED',
        remarks,
        updateType: 'status_change',
      })
      .then(
        (res: any) => {
          this.isLoading = false;
          this.isVisibleFuelAndMileageUpdate = false;
          this.messages.create('success', 'Status Changed to Cancelled');
          this.getPagedOtherReservations();
          this.changingStatus = null;
          this.selectedReservation = null;
        },
        (e: any) => {
          this.messages.create('error', 'Error');
        },
      );
  }

  handleOkUpdateFuelAndMileage(): void {
    this.isLoading = true;
    const allocationDetails = this.selectedReservation?.allocationDetails;

    if (this.changingStatus === 'ON_OTHER_TOUR') {
      allocationDetails.startFuel = this.fuelLevel;
      allocationDetails.startMileage = this.mileage;
      this.otherReservationService
        .updateBooking({
          allocationDetails,
          _id: this.selectedReservation._id,
          status: 'ON_OTHER_TOUR',
          updateType: 'status_change',
        })
        .then(
          (res: any) => {
            this.isLoading = false;
            this.messages.create('success', 'Status Changed to ON OTHER TOUR');
            this.updateFleetData('ON_OTHER_TOUR');
            this.getPagedOtherReservations();
            this.isVisibleFuelAndMileageUpdate = false;
            this.changingStatus = null;
            this.selectedReservation = null;
            this.fuelLevel = 0;
            this.mileage = 0;
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    } else if (this.changingStatus === 'COMPLETED') {
      allocationDetails.endFuel = this.fuelLevel;
      allocationDetails.endMileage = this.mileage;
      this.otherReservationService
        .updateBooking({
          allocationDetails,
          _id: this.selectedReservation._id,
          status: 'COMPLETED',
          updateType: 'status_change',
        })
        .then(
          (res: any) => {
            this.isLoading = false;
            this.messages.create('success', 'Status Changed to Completed');
            this.updateFleetData('AVAILABLE');
            this.getPagedOtherReservations();
            this.isVisibleFuelAndMileageUpdate = false;
            this.changingStatus = null;
            this.selectedReservation = null;
            this.fuelLevel = 0;
            this.mileage = 0;
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    }
  }

  updateFleetData(status: string): void {
    let payload: any = {};
    if (status === 'ON_OTHER_TOUR') {
      payload = {
        _id: this.selectedReservation?.allocationDetails?.allocatedVehicle,
        currentMileage: this.mileage,
        currentFuelLevel: this.fuelLevel,
        currentOnBooking: {
          type: 'OTHER',
          id: this.selectedReservation?._id,
        },
        availabilityStatus: status,
      };
    } else {
      payload = {
        _id: this.selectedReservation?.allocationDetails?.allocatedVehicle,
        currentMileage: this.mileage,
        currentFuelLevel: this.fuelLevel,
        currentOnBooking: null,
        availabilityStatus: status,
      };
    }
    this.fleetService.updateFleet(payload).then(() => {
      this.ngOnInit();
      this.isVisibleFuelAndMileageUpdate = false;
      this.changingStatus = null;
      this.fuelLevel = 0;
      this.mileage = 0;
    });
  }

  addItem(input: HTMLInputElement): void {
    const value = input.value;
    if (this.cancelReasonOptions.indexOf(value) === -1) {
      this.cancelReasonOptions = [
        ...this.cancelReasonOptions,
        input.value || `New item ${this.index++}`,
      ];
    }
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }
}
